"use strict";
/**
 *
 * UTILS: Reusable utility functions used throughout our app
 *
 * These should be utility functions that are used by multiple views,
 * If your util func is only used by your own view, please put it inside your
 * view's lib folder
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuidv4 = exports.noop = void 0;
/**
 * no-op function
 */
const noop = () => { };
exports.noop = noop;
/**
 * uuid generator function
 */
const uuidv4 = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0; // eslint-disable-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8; // eslint-disable-line no-bitwise
    return v.toString(16);
});
exports.uuidv4 = uuidv4;
